import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1A2A44' }, // Dark blue
    secondary: { main: '#00C853' }, // Green
    background: { default: '#F5F7FA', paper: '#FFFFFF' },
    text: { primary: '#1A2A44', secondary: '#757575' },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#1A2A44' },
    secondary: { main: '#00C853' },
    background: { default: '#0D1B2A', paper: '#1E2A3C' },
    text: { primary: '#FFFFFF', secondary: '#B0B0B0' },
  },
});